import apiV2Service from '../api/api-v2.service';
import {
  TargetPlatform,
  TargetPlatformsCampaignUsage,
  TargetPlatformWithDSPs,
} from './targetPlatform.types';

const BASE_PATH = 'TargetPlatforms';

async function fetchTargetPlatforms(): Promise<TargetPlatform[]> {
  const {data} = await apiV2Service.executeGetRequest<TargetPlatform[]>(`${BASE_PATH}`);

  return data;
}

async function fetchTargetPlatformsWithDSPs(): Promise<TargetPlatformWithDSPs[]> {
  const {data} = await apiV2Service.executeGetRequest<TargetPlatformWithDSPs[]>(
    `${BASE_PATH}/list`,
  );

  return data;
}

async function addTargetPlatform(platform: Omit<TargetPlatform, 'id'>): Promise<number> {
  const {data} = await apiV2Service.executePutRequest<number>(`${BASE_PATH}`, {}, {...platform});

  return data;
}

async function updateTargetPlatform(platform: TargetPlatform): Promise<void> {
  await apiV2Service.executePutRequest<void>(`${BASE_PATH}/${platform.id}`, {}, {...platform});
}

async function deleteTargetPlatform(id: number): Promise<void> {
  await apiV2Service.executeDeleteRequest<void>(`${BASE_PATH}/${id}`);
}

async function getTargetPlatformCampaignUsage(id: number): Promise<TargetPlatformsCampaignUsage[]> {
  const {data} = await apiV2Service.executeGetRequest<TargetPlatformsCampaignUsage[]>(
    `${BASE_PATH}/${id}/campaigns`,
  );

  return data;
}

export default {
  fetchTargetPlatforms,
  fetchTargetPlatformsWithDSPs,
  addTargetPlatform,
  updateTargetPlatform,
  deleteTargetPlatform,
  getTargetPlatformCampaignUsage,
};
